export default __webpack_public_path__ + "static/media/restart-button.01801376.png";